module.exports = __webpack_public_path__ + "img/icon-aide-dark.df9bd215.svg";